export enum ClientConsultNoteTaskChoice {
  yes = 'yes',
  notYet = 'not_yet',
  no = 'no',
  assignBackToPar8o = 'assign_back_to_par8o',
  prescriberIsCeProvider = 'prescriber_is_ce_provider',
}
